import { Components, Theme } from '@mui/material';

const muiListItemIcon: Components<Theme>['MuiListItemIcon'] = {
	styleOverrides: {
		root: ({ theme }) => ({
			color: theme.palette.icon,
			minWidth: 32,
		}),
	},
};

export default muiListItemIcon;
